export const SPECS = {
  CallCartV2FromCheckout: 'specs.ecom.CallCartV2FromCheckout',
  CartTooltipWithoutNumber: 'specs.stores.CartTooltipWithoutNumber',
  CartOOIThunderboltCSSOptimization: 'specs.stores.CartOOIThunderboltCSSOptimization',
  ShouldUseOpenSideCartApiInAddToCart: 'specs.stores.ShouldUseOpenSideCartApiInAddToCart',
  ShouldUseEcomPlatformPublicApiAddToCartInPP: 'specs.stores.ShouldUseEcomPlatformPublicApiAddToCartInPP',
  AddSlotToCartPage: 'specs.stores.AddSlotToCartPage',
  ExpressCheckoutInSideCart: 'specs.stores.ExpressCheckoutInSideCart',
  ShowCssPerBreakpointIndicationsSideCart: 'specs.stores.ShowCssPerBreakpointIndicationsSideCart',
  SideCartElementsVisibilityInCss: 'specs.stores.SideCartElementsVisibilityInCss',
  MapCartSummaryColors: 'specs.stores.MapCartSummaryColors',
  GiftCardAddToCartSettings: 'specs.stores.ShowGiftCardAddToCartSettings',
  FixHandleCreateCheckoutError: 'specs.ecom.FixHandleCreateCheckoutError',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  SideCartEditor3SettingsPanel: 'specs.ecom.SideCartEditor3SettingsPanel',
  SideCartEditor3HideSettingsDesignPanel: 'specs.ecom.SideCartEditor3HideSettingsDesignPanel',
  MoveGetClientConfigToControllerFactory: 'specs.ecom.MoveGetClientConfigToControllerFactory',
  PreloadOnCartCheckoutButton: 'specs.ecom.PreloadOnCartCheckoutButton',
  RemoveBackgroudColorCartItemThumbnail: 'specs.ecom.RemoveBackgroudColorCartItemThumbnail',
  MoveCartToViewerContext: 'specs.ecom.MoveCartToViewerContext',
  FixSecureCheckoutBadgeColor: 'specs.ecom.FixSecureCheckoutBadgeColor',
  OnlyCallDeliverySolutionsWhenNeededOnCart: 'specs.ecom.OnlyCallDeliverySolutionsWhenNeededOnCart',
  StopSendingOriginInCheckoutUrl: 'specs.ecom.StopSendingOriginInCheckoutUrl',
  CallCartV2FromCartComponents: 'specs.ecom.CallCartV2FromCartComponents',
  TaxBreakdownInCartPage: 'specs.ecom.TaxBreakdownInCartPage',
  RefactorOrderSummaryInCartPage: 'specs.ecom.RefactorOrderSummaryInCartPage',
  ChangeCartLoaders: 'specs.ecom.ChangeCartLoaders',
  TopCheckoutButtonSkeletonOnCart: 'specs.ecom.TopCheckoutButtonSkeletonOnCart',
  StopFocusOnCart: 'specs.ecom.StopFocusOnCart',
  PricesIncludeTaxFromCart: 'specs.ecom.PricesIncludeTaxFromCart',
  ShowFormsPerLineItemsStep: 'specs.ecom.ShowFormsPerLineItemsStep',
  PlatformFeeOnCartAndCheckout: 'specs.ecom.PlatformFeeOnCartAndCheckout',
  FixOutOfStockOnCart: 'specs.ecom.FixOutOfStockOnCart',
} as const;
